module.exports = __webpack_public_path__ + "static/media/icon-footprint.20faad55.png";